import COLOR_TOKENS from '../indexes/colors.json'

export const colors = {
  ...COLOR_TOKENS.Interface,
  ...COLOR_TOKENS.Editorias,
  ...COLOR_TOKENS.Semântica,
  ...COLOR_TOKENS.TextoEBackground
}